export const POPUP_NOTIFICATION_ENQUEUED = 'POPUP_NOTIFICATION_ENQUEUED';
export const POPUP_NOTIFICATION_CLOSED = 'POPUP_NOTIFICATION_CLOSED';
export const POPUP_NOTIFICATION_REMOVED = 'POPUP_NOTIFICATION_REMOVED';
